<template>
    <div class="main-cart__cart-item-list">
        <transition-group
            name="slide-left"
            v-if="Object.entries(cartItems).length > 0"
        >
            <div
                class="cart-item card"
                v-for="cartItem in Object.values(cartItems).reverse()"
                v-bind:key="'cart_item_' + cartItem._id"
                :class="{ 'is-minimal': hasMinimalItems }"
            >
                <CartItem
                    :cartItem="cartItem"
                    :is-editable="isEditable"
                    :show-attachments="showAttachments"
                    :is-legacy="isLegacy"
                ></CartItem>
            </div>
        </transition-group>
        <div class="cart-item-list is--empty" v-else>
            <h2 class="title is-3 has-text-grey-light">
                Der Warenkorb ist leer.
            </h2>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MATERIAL_MAPPING } from '../../store/constants/material-mapping';
import CartItem from './CartItem';

export default {
    name: 'CartItemList',
    components: { CartItem },
    data() {
        return {
            MATERIAL_MAPPING,
            cartItemsLoaded: false,
        };
    },
    props: {
        cartItems: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
        hasMinimalItems: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAttachments: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLegacy: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    created() {
        this.$store.dispatch('fetchPrintModes');
    },
};
</script>

<style scoped></style>
